import { FormControl, Grid, IconButton, Tooltip, InputLabel, Select, TextField, Typography, Box, Autocomplete } from '@mui/material';
import { Search as IconSearch } from "@mui/icons-material";
import api from "../../services/api";
import moment from 'moment';
import React, { useCallback, useEffect, useState, useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { setValueEntity, setEntity
    , setValidations, initPerson, defaultEntity } from "../../redux/person/personLegalSlice";
import UbigeoSearch from '../UbigeoSearch';
import { FormHelperText as HelperText } from '@mui/material';
import * as personaService from "../../services/personaService";
import * as catalogoService from "../../services/catalogoService";
import AutocompleteLista from '../common/AutocompleteLista';

const PersonaJuridica = (props) => {
    const dispatch = useDispatch();
    const sliceKey = props.sliceKey;
    const isReadOnly = props.isReadOnly;
    const inputRef = useRef(null);

    useEffect(() => {
        dispatch(initPerson({ sliceKey }));
    }, [dispatch, sliceKey]);

    useEffect(() => {
        if (props.autoFocus) {
        const timer = setTimeout(() => inputRef.current?.focus(), 150);
        return () => clearTimeout(timer);
        }
    }, [props.autoFocus]);

    const fechaIngresoMinimo = new Date(2010, 1, 1);

    const entity = useSelector((state) => state.personLegal[sliceKey]?.entity);
    const validate = useSelector((state) => state.personLegal[sliceKey]?.validationActive);

    var validation = {
        razonSocial: {
            error: entity?.razonSocial != null && entity?.razonSocial?.length < 3,
            message: "Falta ingresar la razón social",
        },
        idTipo: {
            error: entity?.idTipo === 0,
            message: "Falta ingresar el tipo de persona juridica",
        },
        fechaIngreso: {
            error: Date.parse(entity?.fechaIngreso) < fechaIngresoMinimo,
            message: "Debe ser una fecha mayor al " + fechaIngresoMinimo.getFullYear(),
        },
    }

    const fetchPersonaJuridica = async () => {
        const response = await personaService.getPersonaJuridica(props.id);
        dispatch(setEntity({sliceKey: sliceKey, data: response ? response : defaultEntity}));
    }
    // Los tipos de la persona juridica: "Tipos de Persona Entidad" (228),
    // con Colegio, Banco, Entidad Financiera, EPS, Empresa de Servicios,
    // Empresa de Transporte y Clinica.
    //
    // Es el mismo catalogo que usa el campo Colegio del mantenimiento de
    // participantes (busca las personas juridicas cuyo tipo es Colegio, el
    // 229), asi que un colegio registrado aqui se puede elegir ahi.
    //
    // El catalogo crece con cada tipo nuevo, asi que el desplegable es un
    // autocomplete: al abrirlo estan los primeros 50 (en orden alfabetico)
    // y al escribir se busca en el servidor.
    const cargarTipos = useCallback(async (texto) => {
        const response = await catalogoService.getCatalogosByPadre(228, texto);
        return (response || []).map((row) => ({ id: row.id, descripcion: row.descripcion }));
    }, []);

    useEffect(() => {
        fetchPersonaJuridica();
        dispatch(setValidations({sliceKey: sliceKey, message: messagesValidation()}));
    }, []);

    useEffect(() => {
        dispatch(setValidations({sliceKey: sliceKey, message: messagesValidation()}));
    }, [entity])

    var handleChange = e => {
        dispatch(setValueEntity({sliceKey: sliceKey, name: e.target.name, value: e.target.value}));
    }
    const messagesValidation = () => {
        var messages = [];

        Object.keys(validation).forEach(function (key) {
            if (validation[key].error) messages.push(validation[key].message)
        })

        return messages;
    }
    
    return (
        <Grid container>
            <Grid item>
                <Box sx={{ fontWeight: 'bold' }} padding={0}>
                    <Typography variant="h7">
                        Datos Basicos
                    </Typography>
                </Box>
            </Grid>
            <Grid container spacing={1} padding={"12px 0px 0px 0px"}>
                <Grid item xs={12} sm={8}>
                    <TextField
                        required
                        name="razonSocial"
                        label="Razon Social"
                        fullWidth
                        value={entity?.razonSocial || ""}
                        onChange={handleChange}
                        error={validate?.razonSocial && validation.razonSocial.error}
                        helperText={validate?.razonSocial && validation.razonSocial.error ? validation.razonSocial.message : ""}
                        size="small"
                        InputLabelProps={{ shrink: true }}
                        disabled={isReadOnly}
                        inputRef={inputRef}
                    />
                </Grid>
                <Grid item xs={6} sm={2}>
                    <TextField
                        required
                        name="fechaIngreso"
                        label="Fecha Ingreso"
                        fullWidth
                        type="date"
                        value={moment(entity?.fechaIngreso || moment()).format('yyyy-MM-DD')}
                        onChange={handleChange}
                        error={validate?.fechaIngreso && validation.fechaIngreso.error}
                        helperText={validate?.fechaIngreso && validation.fechaIngreso.error ? validation.fechaIngreso.message : ""}
                        size="small"
                        InputLabelProps={{ shrink: true }}
                        disabled={isReadOnly}
                    />
                </Grid>
                <Grid item xs={6} sm={2}>
                    <FormControl required fullWidth error={validate?.idTipo && validation.idTipo.error}>
                        <AutocompleteLista
                            label="Tipo"
                            name="idTipo"
                            id="input-tipo"
                            size="small"
                            required
                            disabled={isReadOnly}
                            value={entity?.idTipo || 0}
                            texto={entity?.tipo || ""}
                            cargar={cargarTipos}
                            onChange={(id, texto) => {
                                dispatch(setValueEntity({ sliceKey: sliceKey, name: 'idTipo', value: id }));
                                dispatch(setValueEntity({ sliceKey: sliceKey, name: 'tipo', value: texto }));
                            }}
                        />
                        <HelperText>{validate?.idTipo && validation.idTipo.error ? validation.idTipo.message : ""}</HelperText>
                    </FormControl>
                </Grid>
            </Grid>
        </Grid>
    );
}
export default PersonaJuridica;
